import script from "./MovieSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovieSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./MovieSearchBar.vue?vue&type=style&index=0&id=26f76092&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f76092"]])

export default __exports__